package one.healthium

import kotlinx.browser.window

actual class Platform {
    actual val filesDir: String = "." // TODO
    actual val deviceInfo: DeviceInfo
        get() {
            val userAgent = window.navigator.userAgent
            val platform = window.navigator.platform
            val language = window.navigator.language

            // Parse OS and version from userAgent
            val (os, osVersion) = parseOsInfo(userAgent)

            // Parse device information
            val (device, deviceFamily) = parseDeviceInfo(userAgent, platform)

            // Get font scale factor (not directly available in web, using default)
            val fontScaleFactor = 1f

            return DeviceInfo(
                device = device,
                deviceFamily = deviceFamily,
                os = os,
                osVersion = osVersion,
                language = language.split("-", "_").firstOrNull() ?: "en",
                preferredLanguages = getPreferredLanguages(),
                fontScaleFactor = fontScaleFactor
            )
        }
    actual val cacheDir: String
        get() = "."

    private fun getPreferredLanguages(): List<String> {
        val languages = window.navigator.asDynamic().languages as? Array<String>
        return languages?.mapNotNull {
            it.split("-", "_").firstOrNull()
        }?.ifEmpty { listOf("en") }
            ?: listOf("en")
    }

    private fun parseOsInfo(userAgent: String): Pair<String, String> {
        return when {
            userAgent.contains("Windows NT 10.0") -> "Windows" to "10"
            userAgent.contains("Windows NT 6.3") -> "Windows" to "8.1"
            userAgent.contains("Windows NT 6.2") -> "Windows" to "8"
            userAgent.contains("Windows NT 6.1") -> "Windows" to "7"
            userAgent.contains("Windows NT") -> "Windows" to extractVersion(userAgent, "Windows NT ")
            userAgent.contains("Mac OS X") -> {
                val version = extractMacVersion(userAgent)
                "macOS" to version
            }
            userAgent.contains("iPhone") || userAgent.contains("iPad") -> {
                val version = extractIOSVersion(userAgent)
                "iOS" to version
            }
            userAgent.contains("Android") -> {
                val version = extractVersion(userAgent, "Android ")
                "Android" to version
            }
            userAgent.contains("Linux") -> "Linux" to ""
            else -> "Web" to ""
        }
    }

    private fun parseDeviceInfo(userAgent: String, platform: String): Pair<String, String> {
        return when {
            userAgent.contains("iPhone") -> "iPhone" to "Mobile"
            userAgent.contains("iPad") -> "iPad" to "Tablet"
            userAgent.contains("Android") -> {
                val isMobile = userAgent.contains("Mobile")
                val device = if (isMobile) "Android Phone" else "Android Tablet"
                val family = if (isMobile) "Mobile" else "Tablet"
                device to family
            }
            platform.contains("Mac") || userAgent.contains("Macintosh") -> "Mac" to "Desktop"
            platform.contains("Win") || userAgent.contains("Windows") -> "PC" to "Desktop"
            platform.contains("Linux") -> "Linux PC" to "Desktop"
            else -> "Browser" to "Desktop"
        }
    }

    private fun extractVersion(userAgent: String, prefix: String): String {
        val startIndex = userAgent.indexOf(prefix)
        if (startIndex == -1) return ""

        val versionStart = startIndex + prefix.length
        val versionPart = userAgent.substring(versionStart)
        val endIndex = versionPart.indexOfFirst { !it.isDigit() && it != '.' }

        return if (endIndex == -1) versionPart else versionPart.substring(0, endIndex)
    }

    private fun extractMacVersion(userAgent: String): String {
        val regex = Regex("Mac OS X (\\d+[._]\\d+(?:[._]\\d+)?)")
        val match = regex.find(userAgent)
        return match?.groupValues?.get(1)?.replace('_', '.') ?: ""
    }

    private fun extractIOSVersion(userAgent: String): String {
        val regex = Regex("OS (\\d+[._]\\d+(?:[._]\\d+)?)")
        val match = regex.find(userAgent)
        return match?.groupValues?.get(1)?.replace('_', '.') ?: ""
    }
}